require("../../sitio");
require("bootstrap");

require("@fancyapps/fancybox");
require("@fancyapps/fancybox/dist/jquery.fancybox.css");

require("leaflet");
require("leaflet/dist/leaflet.css");

require("slick-carousel");


// mapa
if (mapa_centro.length && mapa_punto.length) {
    var mymap = L.map("mapid", {
        scrollWheelZoom: false,
    }).setView(mapa_centro, 15);

    var icon = L.icon({
        iconUrl: "../images/proyecto-depto/marker.png",
        shadowUrl: "",

        iconSize: [25, 41], // size of the icon
        shadowSize: [0, 0], // size of the shadow
        iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
        shadowAnchor: [4, 62], // the same for the shadow
        popupAnchor: [0, -40], // point from which the popup should open relative to the iconAnchor
    });

    var marker = L.marker(mapa_punto, { icon: icon })
        .addTo(mymap)
        .bindPopup(mapa_texto)
        .openPopup();

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="https://openstreetmap.org/copyright">baluart.cl</a>'
    }).addTo(mymap);

    mymap.on("click", function (e) {
        var coord = e.latlng.toString().split(",");
        var lat = coord[0].split("(");
        var lng = coord[1].split(")");
        console.log("" + lat[1] + ", " + lng[0]);
    });
}

$("#atributos .atributos").slick({
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    appendArrows: $("#atributos .arrows"),
    prevArrow:
        '<a href="javascript:void(null);" class="arrow arrow-left"><img src="/images/proyecto-casa/flecha_izquierda.svg"/></a>',
    nextArrow:
        '<a href="javascript:void(null);" class="arrow arrow-right"><img src="/images/proyecto-casa/flecha_derecha.svg"/></a>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});
$("#modelos").find(".slide-imagenes").slick({
    infinite: true,
    dots: true,
    arrows: false,
    speed: 300,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
});
$("#galeria-slide").slick({
    infinite: true,
    dots: true,
    arrows: false,
    speed: 300,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick"
        },
        {
            breakpoint: 992,

            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

require("../../components/FormularioProyecto");
